"use client"

import { useEffect } from "react"
import { logError } from "@/lib/log-error"

/**
 * Composant invisible qui capture les erreurs JS globales
 * (non capturees par React Error Boundary) et les envoie au serveur.
 * A monter dans le root layout.
 */
export function ErrorReporter() {
  useEffect(() => {
    function handleError(event: ErrorEvent) {
      logError({
        level: "error",
        source: "window.onerror",
        message: event.message || "Unknown error",
        stack: event.error?.stack,
        url: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : undefined,
      })
    }

    function handleRejection(event: PromiseRejectionEvent) {
      const message = event.reason instanceof Error
        ? event.reason.message
        : String(event.reason)
      const stack = event.reason instanceof Error
        ? event.reason.stack
        : undefined

      logError({
        level: "error",
        source: "unhandled-rejection",
        message,
        stack,
      })
    }

    window.addEventListener("error", handleError)
    window.addEventListener("unhandledrejection", handleRejection)

    return () => {
      window.removeEventListener("error", handleError)
      window.removeEventListener("unhandledrejection", handleRejection)
    }
  }, [])

  return null
}
